import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import {
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../tokens';

export const styledBackstageWarningPanel = (
  theme: Theme,
): BackstageOverrides['BackstageWarningPanel'] => {
  const tokens = getThemeTokens(theme);

  return {
    panel: {
      border: `1px solid ${getSurfaceBorder(theme, 'strong')}`,
      borderRadius: radii.lg,
      boxShadow: 'none',
      maxWidth: '100%',
      overflow: 'hidden',
      '&[class*="MuiAccordion-root"], &[class*="MuiAccordion-rounded"]': {
        borderRadius: radii.lg,
      },
      '&:before': {
        display: 'none',
      },
      '&:first-of-type, &:last-of-type': {
        borderRadius: radii.lg,
      },
    },
    summary: {
      alignItems: 'flex-start',
      boxSizing: 'border-box',
      gap: theme.spacing(1),
      minWidth: 0,
      overflow: 'hidden',
      padding: theme.spacing(1.5, 2),
      '& > svg': {
        flex: '0 0 auto',
        marginRight: 0,
        marginTop: theme.spacing(0.25),
      },
      '& [class*="MuiAccordionSummary-content"]': {
        alignItems: 'flex-start',
        margin: 0,
        minWidth: 0,
        overflow: 'hidden',
      },
      '& [class*="MuiAccordionSummary-expandIcon"]': {
        flex: '0 0 auto',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(-1),
      },
    },
    summaryText: {
      minWidth: 0,
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
    message: {
      backgroundColor: alpha(getSurfaceColor(theme, 'raised'), 0.9),
      color: tokens.textPrimary,
      minWidth: 0,
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
    details: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      borderColor: getSurfaceBorder(theme),
      color: tokens.textPrimary,
      maxWidth: '100%',
      overflow: 'auto',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
  };
};
